export class PermissionByRoleModel {
	title: string;
	key: string;
	permissions: string[];
}
